export enum SeverityLevel {
    Info = 1,
    Warning = 2,
    Error = 3,
}
